import { Box, Container, Stack, Typography } from "@mui/material";
import Admins from "@/templates/Admins";
import { BackButton, Loading, DeleteButton, BackDropLoading } from "@/organism";
import useDetail from "./useDetail";
import { AdmAuth } from "@/constants/code";

export const Detail = () => {
  const {
    isLoading,
    handleAdmUpdate,
    handleAdmPwdUpdate,
    admInfo,
    handleAdmDelete,
  } = useDetail();

  if (!admInfo) {
    return <Loading />;
  }

  return (
    <Container maxWidth={"xl"}>
      <BackDropLoading isLoading={isLoading} />
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/admins"}>관리자 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            관리자명
          </Typography>
        </Stack>
        {admInfo?.admAuth !== AdmAuth.Super && (
          <Stack direction={"row"} gap={1}>
            <DeleteButton
              onClick={() => {
                if (admInfo?.admIdntfcId) {
                  handleAdmDelete(admInfo.admIdntfcId.toString());
                }
              }}
            >
              삭제
            </DeleteButton>
          </Stack>
        )}
      </Box>
      {admInfo && (
        <Admins.EditForm
          admInfo={admInfo}
          onAdmUpdate={handleAdmUpdate}
          onAdmPwdUpdate={handleAdmPwdUpdate}
        />
      )}
    </Container>
  );
};
